module.exports = __webpack_public_path__ + "img/googleLogo.752536d8.svg";